import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import UserBuilderErrors from "./UserBuilderErrors";
import UserBuilderWorkspace from  "./UserBuilderWorkspace";

export default class UserBuilder extends React.Component {

  constructor(props) {
    super(props);

    var user_properties
    this.props.user_properties && this.props.user_properties.length
      ? user_properties = this.props.user_properties.map(property => property.id)
      : user_properties = []

    this.state = {
      active_tab: 'general',
      loading: false,
      read_only: this.props.read_only || false,
      revert: this.props.revert || false,
      version: this.props.version || null,

      /* errors */
      errors: this.props.errors || [],

      /* associations */
      role_names: this.props.role_names || [],
      role_name: this.props.role_name || "",
      role: this.props.role || "",

      /* fields */
      id: this.props.id || null,
      first_name: this.props.first_name || null,
      last_name: this.props.last_name || null,
      email: this.props.email || null,
      mobile_number: this.props.mobile_number || null,
      formatted_phone: this.props.formatted_phone || null,
      password: this.props.password || null,
      password_confirmation: this.props.password_confirmation || null,
      status: this.props.status || 'inactive',
      properties: user_properties,
      two_factor: this.props.two_factor || false,
      superadmin: this.props.superadmin || false,

      /* paths */
      user_revision_history_path: this.props.user_revision_history_path || null,

      /* helpers */
      date_format: this.props.date_format || null,
      time_format: this.props.time_format || null,
      owner: this.props.owner || false,
      modifying_self: this.props.modifying_self || false,
      current_user: this.props.current_user || null,
      admin_role: this.props.admin_role || false,
      date_format: this.props.date_format || false,
      time_format: this.props.time_format || false,
      duplicate: this.props.duplicate || false,
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeFirstName = this.onChangeFirstName.bind(this);
    this.onChangeLastName = this.onChangeLastName.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeMobileNumber = this.onChangeMobileNumber.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangePasswordConfirmation = this.onChangePasswordConfirmation.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    this.onChangeRoleName = this.onChangeRoleName.bind(this);
    this.onChangeProperty = this.onChangeProperty.bind(this);
    this.onChangeTwoFactor = this.onChangeTwoFactor.bind(this);
  };

  componentDidMount() {
    var self = this

    $(window).on("userSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/users/${self.state.id}/data`,
      }).done((data) => {
        self.setState({
          role_name: data.role_name || "",
          first_name: data.first_name || null,
          last_name: data.last_name || null,
          email: data.email || null,
          mobile_number: data.mobile_number || null,
          formatted_phone: data.formatted_phone || null,
          status: data.status || 'inactive',
         });
      });
    });

    $('#new_user').prepend('<input autocomplete="false" name="hidden" type="text" style="display:none;">');
  };

  render() {
    var self = this
    if (this.state.read_only == false) {
      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },

        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          onClick: function (e) {
            self.onSave()
            return false;
          },
        },
      ];
    };
    return (
      <div className="UserBuilder">
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <Tabs tabs={this.tabs()} displayErrorMessage={(UserBuilderErrors.general(this.state.errors).length || UserBuilderErrors.roles(this.state.errors).length) ? true : false} />
        <div className="panel panel-form">
          <UserBuilderWorkspace
            {...this.props}
            {...this.state}
            onChangeFirstName={this.onChangeFirstName}
            onChangeLastName={this.onChangeLastName}
            onChangeEmail={this.onChangeEmail}
            onChangeMobileNumber={this.onChangeMobileNumber}
            onChangePassword={this.onChangePassword}
            onChangePasswordConfirmation={this.onChangePasswordConfirmation}
            onChangeStatus={this.onChangeStatus}
            onChangeName={this.onChangeName}
            onChangeRoleName={this.onChangeRoleName}
            onChangeProperty={this.onChangeProperty}
            onChangeTwoFactor={this.onChangeTwoFactor}
            />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  onChangeActiveTab(name) { 
    // event.stopPropagation();
    // event.preventDefault();
    this.setState({
      active_tab: name
    });
  };

  onChangeFirstName(e) {
    this.setState({
      first_name: e.target.value
    });
  };

  onChangeLastName(e) {
    this.setState({
      last_name: e.target.value
    });
  };

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  };

  onChangeMobileNumber(e) {
    this.setState({
      formatted_phone: e.target.value
    });
  };

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  };

  onChangePasswordConfirmation(e) {
    this.setState({
      password_confirmation: e.target.value
    });
  };

  onChangeStatus(e) {
    this.setState({
      status: e.target.value
    });
  };

  onChangeRoleName(event) {
    var role_name = event.target.value;

    this.setState({
      role_name: role_name
    });
  };

  onChangeProperty(selected_properties) {
    this.setState({properties: selected_properties})
  }

  onChangeTwoFactor(event) {
    this.setState({two_factor: event.target.checked})
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t("general"),
      targetName: "general",
      classes: this.state.active_tab === "general" ? "active" : null,
      changeHandler: this.onChangeActiveTab,
      tabErrorCount: UserBuilderErrors.general(this.state.errors).length,
    });

    if (this.state.superadmin != true) {
      tabs.push({
        tabName: I18n.t('roles'),
        targetName: 'roles',
        classes: this.state.active_tab === 'roles' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
        tabErrorCount: UserBuilderErrors.roles(this.state.errors).length
      })
    }

    if (this.state.read_only && this.state.revert != true && this.state.superadmin != true) {
      tabs.push({
        tabName: I18n.t('history'),
        targetName: 'history',
        classes: this.state.active_tab === 'history' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
      })
    }

    return tabs;
  }

  prepParams() {
    var user = {
      id: this.state.id,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      mobile_number: this.state.mobile_number,
      formatted_phone: this.state.formatted_phone,
      password: this.state.password,
      password_confirmation: this.state.password_confirmation,
      status: this.state.status,
      role_name: this.state.role_name == 'none' ? null : this.state.role_name,
      property_ids: this.state.properties,
      otp_required_for_login: this.state.two_factor,
      updated_at: this.props.updated_at,
      created_at: this.props.created_at,
      duplicate: this.state.duplicate,
    }

    return user
  }

  onSave() {
    var self = this;
    var user = self.prepParams()
    this.setState({ loading: true });
    $.ajax({
      type: this.props.new_record ? 'POST' : 'PATCH',
      url: this.props.new_record ? `/admin/users` : `/admin/users/${this.state.id}`,
      data: {
        user: user
      }
    }).done((data) => {
      window.parent.$(window.parent).trigger('roleSaved', data);
        if (data && data.errors) {
          this.setState({ errors: data.errors, loading: false });
          $('.modal-body').scrollTop(0);
        } else {
          this.setState({ loading: false });
          if (parent && parent.refresh_data) {
            parent.refresh_data(this.props.new_record ? I18n.t('user_successfully_created') : I18n.t('user_successfully_saved'));
          };

          if (parent && parent.hide_modal) {
            parent.hide_modal();
          };
        }
    })
    .catch((data) => {
      if (data && data.responseJSON) {
        this.setState({ errors: data.responseJSON, loading: false });
        $('.modal-body').scrollTop(0);
      }
    });
  };

};